import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Tab,
  Typography
} from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomSelect from '../../../../../common/components/customized/customselect/CustomSelect';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import { useAppDispatch, useAppSelector } from '../../../../../app/redux/hooks';
import React, { SyntheticEvent, useCallback, useEffect, useRef, useState } from 'react';
import CustomButton from '../../../../../common/components/buttons/CustomButton';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import GoogleSearchBox from '../../../../../common/components/maps/googlesearchbox/GoogleSearchBox';
import { getDevices } from '../../../../yaantrac/redux/reducer/yaantracSlices/reportSlice';
import {
  convertDatetoEpoch,
  convertToEpoch2,
  debounce,
  findAddress,
  useAbort
} from '../../../../../utils/commonFunctions';
import PhoneNoTextField from '../../../../../common/components/customized/customtextfield/PhoneNoTextField';
import dayjs from 'dayjs';
import {
  addDeliveryTripsAction,
  clearDeliveryPreview,
  DeliveryTripPayload,
  getContactData,
  getContactNumber,
  previewDeliveryTrip,
  updateDeliveryTrips
} from '../../../redux/reducer/deliveryTrackingSlices/deliverytripsSlice';
import './AddDeliveryTrip.scss';
import CustomRadioButton from '../../../../../common/components/customized/customradiobutton/CustomRadioButton';
import CustomDateTimeCalendar from '../../../../../common/components/customized/customdatetimecalendar/CustomDateTimeCalendar';
// import { debounce } from 'lodash';
import { getDriverslist } from '../../../../yaantrac/redux/reducer/yaantracSlices/mytripsSlice';
import GoogleMap from '../../../../../common/components/maps/googlemap/GoogleMap';
import CustomIconButton from '../../../../../common/components/buttons/CustomIconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AddCircleOutline, Visibility } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import GoogleTripDirections from '../../../../../common/components/maps/googledirection/GoogleTripDirections';
import { decode } from '@googlemaps/polyline-codec';
import { updatePolyline } from '../../../../../common/redux/reducer/commonSlices/polylineSlice';
import GooglePolyline from '../../../../../common/components/maps/googlepolyline/GooglePolyline';
import {
  updateCenter,
  updateZoom
} from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import { updateCustomer } from '../../../redux/reducer/deliveryTrackingSlices/customerDeliverySlice';
import { Icon } from '@iconify/react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import BackspaceIcon from '@mui/icons-material/Backspace';
import { getAllTrips } from '../../../redux/reducer/deliveryTrackingSlices/khubtripsSlice';
interface DeliveryBox {
  barcodeId: string;
  noOfBox: string;
}
interface CustomerInfo {
  customerId: string;
  assignedOrderId: string;
  deliverableType: string;
  customerName: string;
  contactNumber: string;
  lastName: string;
  deliverableAddress: string;
  deliverableLat: number;
  deliverableLng: number;
  noOfBoxes: number;
  successfulScanCount: number;
  barcodeMapList: [
    {
      barcodeId: string;
      isScanned: string;
    }
  ];
  status: string;
  timezone: string;
  isDeleted: number;
}

interface SelectedRow {
  startTime: string;
  startDate: string;
  status: string;
  totalDeliverables: number;
  successfulDeliverables: number;
  failedDeliverables: number;
  completedDeliverables: number;
  totalOrderDeliverables: number;
  totalSalesDeliverables: number;
  completedOrderDeliverables: number;
  completedSalesDeliverables: number;
  tripDeliverablesType: string;
  isTripCompleted: number;
  tripTotalDistance_KM: number;
  tripTotalDuration_HRS_MIN: string;
  totalBoxesCount: number;
  successfulScanCount: number;
  timezone: string;
  adhocStops: number;
  isdeleted: number;
  driverID: string;
  createdAt: number;
  sourceLat: number;
  sourceLng: number;
  startTimestamp: number;
  endTimestamp: number;
  sourceAddress: string;
  tripID: number;
  adhocStopResponses: [];
  vehicleNumber: string;
  overSpeedID: number;
  startTimeDate: string;
  driverNames: string;
  id: number;
  endDate: string;
  tripDeliveriesInfo: {
    deliverablesInfoList: CustomerInfo[];
    driverName: string;
    mobileNumber: string;
  };
}

interface AddDeliveryProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedRow: SelectedRow;
  setSelectedRow: React.Dispatch<React.SetStateAction<SelectedRow | null>>;
  setTabValue: React.Dispatch<React.SetStateAction<number>>;
}

interface DeliveryLocation {
  name: string;
  delivery: string;
  deliveryLat: number;
  deliveryLng: number;
}

const AddDeliveryTrip = ({
  isOpen,
  setIsOpen,
  selectedRow,
  setSelectedRow,
  setTabValue
}: AddDeliveryProps) => {
  const [mobilenumberDropdown, setMobilenumberDropdown] = useState([]);
  const [sourceAddress, setSourceAddress] = useState<any>(null);
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<string>('0');
  const [deliveryLocation, setDeliveryLocation] = useState<DeliveryLocation[]>([]);
  const [visitType, setVisitType] = useState('');
  const [vehicleNumber, setVehicleNumber] = useState('');
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [deliveryRows, setDeliveryRows] = useState([]);
  const [selectedCustomerIndex, setSelectedCustomerIndex] = useState<number | null>(null);
  const [tripMarkers, setTripMarkers] = useState<any[]>([]);
  const [showCalendar, setShowCalendar] = useState<boolean>(false);
  const [customerDetails, setCustomerDetails] = useState<any>([
    {
      customerName: '',
      contactNumber: '',
      deliveryAddress: { delivery: '', deliveryLat: 0, deliveryLng: 0 },
      visitType: '',
      orderList: [],
      isUpdate: false,
      isExisting: 'Existing Customer',
      isExpanded: false
    }
  ]);
  const [minDateTime, setMinDateTime] = useState<any>(null);
  const [maxDateTime, setMaxDateTime] = useState<any>(null);
  const customerName = useRef<any>(null);
  const [deletedCustomers, setDeletedCustomers] = useState<any>([]);

  const dispatch = useAppDispatch();
  const createAbort = useAbort();

  const schema = yup.object().shape({
    startTime: yup
      .object()
      .required('Select date and time')
      .test('not-empty', 'Select date and time', function (value) {
        return Object.keys(value).length !== 0;
      }),
    endTime: yup
      .object()
      .required('Select end date and time')
      .test('not-empty', 'Select end date and time', function (value) {
        return Object.keys(value).length !== 0;
      }),
    vehicleNumber: yup.string().required('Select vehicle number'),
    sourceAddress: yup.object().shape({
      source: yup.string().required('Enter source address'),
      startLat: yup.number().required('Enter source latitude'),
      startLng: yup.number().required('Enter source longitude')
    }),
    driverId: yup.string().required('Select driver ID'),
    customerList: yup
      .array()
      .of(
        yup.object().shape({
          customerType: yup.string().notRequired(),
          customer: yup.string().when('customerType', {
            is: 'Existing Customer',
            then: () => yup.string().required('Select Exisiting Customer'),
            otherwise: () => yup.string().notRequired()
          }),
          customerName: yup.string().required('Enter the Customer name'),

          contactNumber: yup
            .string()
            .required('Select contact number')
            .min(5, 'Enter a valid contact number'),
          deliveryAddress: yup.object().shape({
            delivery: yup.string().required('Enter delivery address'),
            deliveryLat: yup.number().required('Enter delivery latitude'),
            deliveryLng: yup.number().required('Enter delivery longitude')
          }),
          visitType: yup.string().required('Select order type'),
          orderList: yup
            .array()
            .of(
              yup.object().shape({
                deliveryBoxes: yup.object().shape({
                  barcodeId: yup
                    .array()
                    .of(
                      yup
                        .string()
                        .matches(
                          /^[A-Za-z0-9\s]+$/,
                          'Barcode ID must contain only alphabets or numbers'
                        )
                    ),
                  noOfBox: yup.number()
                })
              })
            )
            .default([])
            .when('visitType', {
              is: 'ORDER_DELIVERY',
              then: schema =>
                schema.of(
                  yup.object().shape({
                    deliveryBoxes: yup.object().shape({
                      barcodeId: yup.array().of(
                        yup
                          .string()
                          .required('Enter the Barcode ID')
                          .matches(
                            /^[A-Za-z0-9\s]+$/,
                            'Barcode ID must contain only alphabets or numbers'
                          )
                          .typeError('Enter the Barcode ID')
                          .min(13, 'Barcode ID must be exactly 13 characters')
                          .max(13, 'Barcode ID must be exactly 13 characters')
                      ),
                      noOfBox: yup
                        .string()
                        .required('Enter the number of Box')
                        .min(1, 'Number of Box must be at least 1')
                        .typeError('Number of Box must be a number')
                    })
                  })
                ),
              otherwise: schema =>
                schema.of(
                  yup.object().shape({
                    deliveryBoxes: yup.object().shape({
                      barcodeId: yup.array().of(yup.string().notRequired()),
                      noOfBox: yup.string().notRequired()
                    })
                  })
                )
            }),
          isUpdate: yup.boolean().default(false),
          isExisting: yup.string().default('Existing Customer')
        })
      )
      .default([])
  });

  const { deviceList } = useAppSelector(state => state.devicelist);
  const { driverIdData, isLoading } = useAppSelector(state => state.driverId);
  const { contactNumberData, isLoading: contactLoading } = useAppSelector(
    state => state.contactNumber
  );
  const { data: driverList } = useAppSelector((state: any) => state.drivertripsdata);
  const { contactData } = useAppSelector(state => state.contactData);
  const { data } = useAppSelector(state => state.deliveryAndOrders);
  const { isLoading: addLoading } = useAppSelector(state => state.addDeliveryTripSlice);
  const { isLoading: updateLoading } = useAppSelector(state => state.updateDelivery);
  const { isLoading: previewLoading, data: previewData } = useAppSelector(
    state => state.deliveryPreview
  );
  const { paths } = useAppSelector(state => state.polyline);
  const [width, setWidth] = useState(800);
  const boxRef = useRef(null);

  const {
    control,
    handleSubmit,
    setValue,
    clearErrors,
    getValues,
    trigger,
    resetField,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      startTime: {},
      endTime: {},
      vehicleNumber: '',
      sourceAddress: {
        source: '',
        startLat: 0,
        startLng: 0
      },
      driverId: '',
      customerList: customerDetails
    }
  });

  const {
    fields: customerFields,
    append: appendCustomer,
    update: updaetCustomer,
    remove: removeCustomer
  } = useFieldArray({
    control,
    name: 'customerList'
  });
  const contactOptions = contactNumberData.map((value: any) => ({
    id: value,
    label: value
  }));
  const availableDriversList =
    driverList?.length > 0
      ? driverList?.map((item: any) => ({
          id: item?.driverId,
          label: item?.driverName
        }))
      : [];

  const handleAddCustomer = () => {
    let availableMobNo = customerFields?.map((item: any) => item?.contactNumber);
    const filteredMobileNo = mobilenumberDropdown?.filter(
      (value: any) => !availableMobNo?.includes(value?.id)
    );
    appendCustomer({
      customerName: '',
      contactNumber: '',
      deliveryAddress: { delivery: '', deliveryLat: 0, deliveryLng: 0 },
      visitType: '',
      orderList: [],
      isUpdate: false,
      contactNumberDropdown: filteredMobileNo,
      isExisting: 'Existing Customer',
      isExpanded: false
    });
    setActiveTab(String(customerFields.length));
    setVisitType('');
  };

  // const handleAddBox = (customerIndex: number, orderIndex: number, count: number) => {
  //   const orderPath =
  //     `customerList.${customerIndex}.orderList.${orderIndex}.deliveryBoxes` as const;
  //   const activeCustomer = getValues(`customerList.${customerIndex}`);
  //   const currentBoxes: any = getValues(orderPath) as DeliveryBox[];

  //   const updatedBoxes = {
  //     ...currentBoxes,
  //     barcodeId: [
  //       ...currentBoxes.barcodeId,
  //       ...Array.from({
  //         length:
  //           count && currentBoxes.barcodeId?.length >= 1
  //             ? count - currentBoxes.barcodeId?.length
  //             : !selectedRow && count
  //             ? 1
  //             : 0
  //       }).fill('')
  //     ]
  //   };
  //   updaetCustomer(customerIndex, {
  //     ...customerFields[customerIndex],
  //     orderList: [{ deliveryBoxes: updatedBoxes }]
  //   });
  // };

  const handleAddBox = (customerIndex: number, orderIndex: number, count: number) => {
    const orderPath = `customerList.${customerIndex}.orderList.${orderIndex}.deliveryBoxes.barcodeId`;

    // Get current barcodeId array
    const currentBarcodeIds = getValues(orderPath as any) || [];

    // Adjust barcodeId array length based on `count`
    let updatedBarcodeIds = [...currentBarcodeIds];

    if (count > currentBarcodeIds.length) {
      // Add empty barcode IDs
      updatedBarcodeIds = [
        ...currentBarcodeIds,
        ...new Array(count - currentBarcodeIds.length).fill('')
      ];
    } else {
      // Remove extra barcode IDs
      updatedBarcodeIds = updatedBarcodeIds.slice(0, count);
    }
    // Update barcodeId field
    setValue(orderPath as any, updatedBarcodeIds);
    clearErrors(`customerList.${customerIndex}.orderList.${orderIndex}.deliveryBoxes`);
  };

  const handleClose = () => {
    setSelectedRow(null);
    setIsOpen(false);
  };

  const visitTypeData = ['ORDER DELIVERY', 'DIRECT SALES'].map(value => ({
    id: value.replace(' ', '_'),
    label: value
  }));

  const onSubmit = async (params: any) => {
    if (selectedRow) {
      let deletedCustomerList = [
        ...params.customerList.map((customer: any) => ({
          customerName: customer.customerName,
          contactNumber: customer.contactNumber,
          deliveryAddress: customer?.deliveryAddress.delivery,
          deliverableLat: customer?.deliveryAddress.deliveryLat,
          deliverableLng: customer?.deliveryAddress.deliveryLng,
          visitType: customer.visitType,
          tempDelete: false,
          orderList: customer.orderList.map((order: any) => ({
            totalBoxesCount: order.deliveryBoxes.noOfBox,
            deliveryBoxes: order.deliveryBoxes.barcodeId?.map((item: any) => ({
              barcodeId: item
            }))
          }))
        })),
        ...deletedCustomers
      ];
      let updatePayload: any = {
        driverId: params?.driverId,
        vehicleNumber: params?.vehicleNumber,
        assignedTripId: params?.assignedTripId,
        sourceAddress: params?.sourceAddress.source,
        sourceLat: params?.sourceAddress?.startLat,
        sourceLng: params?.sourceAddress?.startLng,
        startTimestamp: convertDatetoEpoch(params.startTime) / 1000,
        endTimestamp: convertDatetoEpoch(params.endTime) / 1000,
        timezone: 'Asia/Kolkata',
        customerList: deletedCustomerList
      };
      let pay: { updatePayload: any; tripID: any } = {
        updatePayload: updatePayload,
        tripID: selectedRow.tripID
      };
      let response = await dispatch(updateDeliveryTrips(pay));
      if (response?.payload?.status === 'Success') {
        setIsOpen(false);
        setTabValue(1);
        await dispatch(getAllTrips({ status: 'Scheduled', pageno: 1, pagesize: 5 }));
      }
    } else {
      let response = await dispatch(
        addDeliveryTripsAction({
          driverId: params?.driverId,
          vehicleNumber: params?.vehicleNumber,
          assignedTripId: params?.assignedTripId,
          sourceAddress: params?.sourceAddress.source,
          sourceLat: params?.sourceAddress?.startLat,
          sourceLng: params?.sourceAddress?.startLng,
          startTimestamp: convertDatetoEpoch(params.startTime) / 1000,
          endTimestamp: convertDatetoEpoch(params.endTime) / 1000,
          timezone: 'Asia/Kolkata',
          customerList: params.customerList.map((customer: any) => ({
            customerName: customer.customerName,
            contactNumber: customer.contactNumber,
            deliveryAddress: customer?.deliveryAddress.delivery,
            deliverableLat: customer?.deliveryAddress.deliveryLat,
            deliverableLng: customer?.deliveryAddress.deliveryLng,
            visitType: customer.visitType,
            orderList: customer.orderList.map((order: any) => ({
              totalBoxesCount: order.deliveryBoxes.noOfBox,
              deliveryBoxes: order.deliveryBoxes.barcodeId?.map((item: any) => ({
                barcodeId: item
              }))
            }))
          }))
        })
      );
      if (response?.payload?.status === 200) {
        setIsOpen(false);
        setTabValue(1);
        await dispatch(getAllTrips({ status: 'Scheduled', pageno: 1, pagesize: 5 }));
      }
    }
  };

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  const handleDeliveryLocationChange = (customerIndex: number, location: any) => {
    if (location?.formatted_address) {
      let deliveryAddress = {
        name: `waypoint${customerIndex}`,
        delivery: location?.formatted_address,
        deliveryLat: location?.geometry.location.lat(),
        deliveryLng: location?.geometry.location.lng()
      };
      setDeliveryLocation((prev: any) => {
        const updatedLocations = [...prev];
        updatedLocations[customerIndex] = deliveryAddress;
        return updatedLocations;
      });
      setValue(`customerList.${customerIndex}.deliveryAddress`, deliveryAddress);
      clearErrors(`customerList.${customerIndex}.deliveryAddress`);
      updaetCustomer(customerIndex, {
        customerName: getValues(`customerList.${customerIndex}.customerName`),
        contactNumber: getValues(`customerList.${customerIndex}.contactNumber`),
        deliveryAddress: deliveryAddress,
        contactNumberDropdown: getValues(
          `customerList.${customerIndex}.contactNumberDropdown`
        ),
        isExisting: getValues(`customerList.${customerIndex}.isExisting`),
        isUpdate: getValues(`customerList.${customerIndex}.isUpdate`),
        isExpanded: getValues(`customerList.${customerIndex}.isExpanded`),
        orderList: getValues(`customerList.${customerIndex}.orderList`),
        visiType: getValues(`customerList.${customerIndex}.visiType`)
      });
    }
    clearDateandDriverDetails();
  };

  const handleCustomerChange = (e: any, customerIndex: number) => {
    updaetCustomer(customerIndex, {
      ...customerFields[customerIndex],
      isExisting: e.target.value
    });
    const isExisting = e.target.value === 'Existing Customer';
    if (!isExisting) {
      updaetCustomer(customerIndex, {
        ...customerFields[customerIndex],
        isExisting: e.target.value,
        customerName: '',
        contactNumber: '',
        deliveryAddress: {
          delivery: '',
          deliveryLat: null,
          deliveryLng: null
        }
      });
      setDeliveryLocation((prev: any) => {
        const updateLocations = prev?.filter(
          (item: any, index: number) => index !== customerIndex
        );
        return updateLocations;
      });
      setValue(`customerList.${customerIndex}.customerName`, '');
      setValue(`customerList.${customerIndex}.contactNumber`, '');
      setValue(`customerList.${customerIndex}.deliveryAddress`, {
        delivery: '',
        deliveryLat: null,
        deliveryLng: null
      });
      setValue(`customerList.${customerIndex}.visitType`, '');
    }
    setSelectedContactId(null);
    setVisitType('');
  };

  const handleContactChange = async (newValue: any, customerIndex: number) => {
    let previousIndexValue = getValues(`customerList.${customerIndex}.contactNumber`);
    customerFields.forEach((item: any, index: number) => {
      let customerNumbers = customerFields
        ?.map((item: any) => item?.contactNumber)
        .filter((filterValue: any, index: number) => filterValue);
      if (customerIndex !== index) {
        let filteredNumbers: any = mobilenumberDropdown?.filter((value: any) => {
          if (value?.id === item?.contactNumber) {
            return true;
          } else if (
            !customerNumbers?.includes(value?.id) &&
            newValue?.id !== value?.id
          ) {
            return true;
          }
        });
        if (!newValue) {
          filteredNumbers = [
            ...filteredNumbers,
            { id: previousIndexValue, label: previousIndexValue }
          ];
        }

        updaetCustomer(index, {
          ...customerFields[index],
          contactNumberDropdown: filteredNumbers
        });
      } else if (newValue) {
        updaetCustomer(index, {
          ...customerFields[index],
          contactNumber: newValue?.id ?? ''
        });
      }
    });

    if (newValue?.id) {
      setSelectedCustomerIndex(customerIndex);
      setSelectedContactId(newValue.id);
      setValue(`customerList.${customerIndex}.contactNumber`, newValue?.id);
      await dispatch(getContactData(newValue.id));
    } else if (!newValue) {
      clearDateandDriverDetails();
      updaetCustomer(customerIndex, {
        ...customerFields[customerIndex],
        customerName: '',
        contactNumber: '',
        deliveryAddress: { delivery: '', deliveryLat: 0, deliveryLng: 0 },
        visitType: '',
        orderList: [
          {
            deliveryBoxes: { barcodeId: [''], noOfBox: 1 }
          }
        ]
      });
      setDeliveryLocation((prev: any) => {
        let filteredLocation = prev?.filter(
          (item: any, index: number) => index !== customerIndex
        );
        return filteredLocation;
      });
    }
  };

  //function to handle delivery preview
  const handlePreviewDelivery = async () => {
    let payload: DeliveryTripPayload = {
      vehicleNumber: vehicleNumber,
      sourceAddress: sourceAddress.formatted_address,
      sourceLat: sourceAddress.startLat,
      sourceLng: sourceAddress.startLng,
      customerList: deliveryLocation?.map((item: DeliveryLocation, index: number) => ({
        deliveryAddress: item?.delivery,
        deliverableLat: item?.deliveryLat,
        deliverableLng: item?.deliveryLng
      }))
    };

    await dispatch(previewDeliveryTrip(payload));
  };

  //function to clear startDate ,endDate and driverID
  const clearDateandDriverDetails = () => {
    if (fromDate) {
      setFromDate(null);
      setValue('startTime', {});
    }
    if (toDate) {
      setToDate(null);
      setValue('endTime', {});
    }
    setValue('driverId', '');
    dispatch(clearDeliveryPreview());
  };

  //function to control button and field disable
  const handleDisable = (name: string) => {
    switch (name) {
      case 'preview':
        return ![
          Boolean(sourceAddress),
          tripMarkers?.length > 1,
          Boolean(vehicleNumber)
        ].every(item => item === true);
      case 'start-date':
        return ![Boolean(sourceAddress), tripMarkers?.length > 1, showCalendar].every(
          item => item === true
        );
      case 'end-date':
        return ![
          Boolean(sourceAddress),
          tripMarkers?.length > 1,
          showCalendar,
          Boolean(fromDate)
        ].every(item => item === true);
      case 'driverid':
        return ![Boolean(fromDate), Boolean(toDate)].every(item => item === true);
    }
  };

  // // update value in updaetCustomer
  // const handleFields = debounce(
  //   (name: string, customerIndex: number, fieldname: string) => {
  //     updaetCustomer(customerIndex, {
  //       ...customerFields[customerIndex],
  //       [`${fieldname}`]: name
  //     });
  //   },
  //   2000
  // );

  // const handleFields = useCallback(
  //   debounce((name: string, customerIndex: number, fieldname: string) => {
  //     console.log('first');
  //     updaetCustomer(customerIndex, {
  //       ...customerFields[customerIndex],
  //       [`${fieldname}`]: name
  //     });
  //   }),
  //   [updateCustomer, customerFields]
  // );

  const handleFields = (name: string, customerIndex: number, fieldname: string) => {
    setValue(`customerList.${customerIndex}.${fieldname}`, name, {
      shouldValidate: true
    });
    // updaetCustomer(customerIndex, {
    //   ...customerFields[customerIndex],
    //   [`${fieldname}`]: name
    // });
  };

  //function to handle delivery markers
  const handleDeliveryMarker = async (e: any, marker: any) => {
    let fAdd = await findAddress(e?.latLng?.lat(), e?.latLng?.lng());
    if (marker === 'source') {
      setSourceAddress({
        formatted_address: fAdd,
        startLat: e?.latLng?.lat(),
        startLng: e?.latLng?.lng()
      });
    } else {
      setDeliveryLocation((prev: any) => {
        let updatedLocations = prev?.map((delivery: any) => {
          if (delivery.name === marker) {
            return {
              ...delivery,
              delivery: fAdd,
              deliveryLat: e?.latLng?.lat(),
              deliveryLng: e?.latLng?.lng()
            };
          } else {
            return delivery;
          }
        });
        return updatedLocations;
      });
    }
  };

  //function to check details are filled
  const checkDetails = (customer: any) => {
    const {
      isExisting,
      isUpdate,
      contactNumberDropdown,
      id,
      orderList,
      isExpanded,
      deliveryAddress,
      ...rest
    } = customer;
    const basicFields = Object.values(rest).every(Boolean);
    const orderType =
      rest.visitType === 'DIRECT SALES'
        ? orderList?.length === 0
        : orderList?.length > 0 &&
          orderList[0]?.deliveryBoxes?.noOfBox >= 1 &&
          orderList[0]?.deliveryBoxes?.barcodeId.every(
            (item: any) => Boolean(item) && item.length === 13
          );
    const address = Object.values(deliveryAddress).every(Boolean);
    return [basicFields, orderType, address].every(Boolean);
  };

  // const handleBarcodeId = debounce((value, customerIndex, orderIndex, boxIndex) => {
  //   updaetCustomer(customerIndex, {
  //     ...customerFields[customerIndex],
  //     orderList: [
  //       {
  //         deliveryBoxes: {
  //           noOfBox: (customerFields as any)[customerIndex].orderList[orderIndex]
  //             .deliveryBoxes.noOfBox,
  //           barcodeId: (customerFields as any)[customerIndex].orderList[
  //             orderIndex
  //           ].deliveryBoxes.barcodeId?.map((item: any, index: any) =>
  //             index === boxIndex ? value : item
  //           )
  //         }
  //       }
  //     ]
  //   });
  // });

  //function to handle deleted customer
  // const handleBarcodeId = debounce((value, customerIndex, orderIndex, boxIndex) => {
  //   const fieldPath = `customerList.${customerIndex}.orderList.${orderIndex}.deliveryBoxes.barcodeId`;

  //   // Get the latest barcodeId array
  //   const currentBarcodeIds = getValues(fieldPath as any) || [];

  //   // Update the specific index
  //   const updatedBarcodeIds = currentBarcodeIds.map((item: any, index: any) =>
  //     index === boxIndex ? value : item
  //   );

  //   // Set the updated array
  //   setValue(fieldPath as any, updatedBarcodeIds, { shouldValidate: true });
  // });

  const removedCustomers = (customer: any) => {
    let deleteCustomers = {
      customerName: customer.customerName,
      contactNumber: customer.contactNumber,
      deliveryAddress: customer?.deliveryAddress.delivery,
      deliverableLat: customer?.deliveryAddress.deliveryLat,
      deliverableLng: customer?.deliveryAddress.deliveryLng,
      visitType: customer.visitType,
      tempDelete: true,
      orderList: customer.orderList.map((order: any) => ({
        totalBoxesCount: order.deliveryBoxes.noOfBox,
        deliveryBoxes: order.deliveryBoxes.barcodeId?.map((item: any) => ({
          barcodeId: item
        }))
      }))
    };
    setDeletedCustomers((prev: any) => [...prev, deleteCustomers]);
  };

  useEffect(() => {
    if (sourceAddress?.formatted_address && !selectedRow) {
      setValue('sourceAddress', {
        source: sourceAddress?.formatted_address,
        startLat: sourceAddress?.startLat,
        startLng: sourceAddress?.startLng
      });
    }
  }, [sourceAddress, selectedRow]);

  useEffect(() => {
    if (data?.length > 0) {
      setDeliveryRows(data);
    } else if (data?.length === 0) {
      setDeliveryRows([]);
    }
  }, [data]);

  useEffect(() => {
    if (selectedRow) {
      const mobileDropdown = contactNumberData?.map((item: any) => ({
        id: item,
        label: item
      }));
      setMobilenumberDropdown(mobileDropdown);
      setValue('startTime', dayjs.unix(selectedRow?.startTimestamp));
      setValue('endTime', dayjs.unix(selectedRow?.endTimestamp));
      setValue('vehicleNumber', selectedRow?.vehicleNumber);
      setSourceAddress({
        formatted_address: selectedRow?.sourceAddress,
        startLat: selectedRow?.sourceLat,
        startLng: selectedRow?.sourceLng
      });
      setValue('sourceAddress', {
        source: selectedRow?.sourceAddress,
        startLat: selectedRow?.sourceLat,
        startLng: selectedRow?.sourceLng
      });
      setValue('driverId', selectedRow?.driverID);

      const updatedDelivery: any = [];

      selectedRow?.tripDeliveriesInfo?.deliverablesInfoList?.forEach(
        (item: any, customerIndex: number) => {
          setValue(
            `customerList.${customerIndex}.customerRadio`,
            item.customerId ? 'Existing Customer' : 'New Customer'
          );
          updatedDelivery.push({
            name: `waypoint${customerIndex}`,
            delivery: item?.deliverableAddress,
            deliveryLat: item?.deliverableLat,
            deliveryLng: item?.deliverableLng
          });
          updaetCustomer(customerIndex, {
            firstName: item.firstName,
            lastName: item.lastName,
            contactNumber: item.contactNumber,
            deliveryAddress: {
              delivery: item?.deliverableAddress,
              deliveryLat: item?.deliverableLat,
              deliveryLng: item?.deliverableLng
            },
            visitType: item?.deliverableType,
            orderList: [
              {
                deliveryBoxes: {
                  barcodeId: item?.barcodeMapList?.map((item: any) => item?.barcodeId),
                  noOfBox: item?.noOfBoxes
                }
              }
            ],
            contactNumberDropdown: contactOptions,
            isUpdate: true,
            isExpanded: false,
            isExisting: 'Existing Customer'
          });
        }
      );

      setVehicleNumber(selectedRow.vehicleNumber);

      setDeliveryLocation(updatedDelivery);
      let updateFromDate: any = dayjs.unix(selectedRow?.startTimestamp);
      setFromDate(updateFromDate.$d);
      let updateEndDate: any = dayjs.unix(selectedRow?.endTimestamp);
      setToDate(updateEndDate);
      let payload: DeliveryTripPayload = {
        vehicleNumber: selectedRow.vehicleNumber,
        sourceAddress: selectedRow?.sourceAddress,
        sourceLat: selectedRow.sourceLat,
        sourceLng: selectedRow.sourceLng,
        customerList: updatedDelivery?.map((item: DeliveryLocation, index: number) => ({
          deliveryAddress: item?.delivery,
          deliverableLat: item?.deliveryLat,
          deliverableLng: item?.deliveryLng
        }))
      };
      dispatch(previewDeliveryTrip(payload));
    }
  }, [selectedRow]);

  useEffect(() => {
    if (contactData && selectedContactId !== null && selectedCustomerIndex !== null) {
      updaetCustomer(selectedCustomerIndex, {
        ...customerFields[selectedCustomerIndex],
        firstName: contactData.firstName,
        lastName: contactData.lastName,
        deliveryAddress: {
          delivery: contactData.deliveryAddress,
          deliveryLat: contactData.deliverableLat,
          deliveryLng: contactData.deliverableLng
        }
      });

      setDeliveryLocation((prevLocations: any) => {
        const updatedLocations = [...prevLocations];
        updatedLocations[selectedCustomerIndex] = {
          name: `waypoint${selectedCustomerIndex}`,
          delivery: contactData.deliveryAddress,
          deliveryLat: contactData.deliverableLat,
          deliveryLng: contactData.deliverableLng
        };

        return updatedLocations;
      });
    }
  }, [contactData, selectedContactId, selectedCustomerIndex, setValue]);

  useEffect(() => {
    if (!selectedRow) {
      const contactOptions = contactNumberData.map((value: any) => ({
        id: value,
        label: value
      }));
      setMobilenumberDropdown(contactOptions);
      updaetCustomer(0, {
        firstName: '',
        lastName: '',
        contactNumber: '',
        deliveryAddress: { delivery: '', deliveryLat: 0, deliveryLng: 0 },
        visitType: '',
        orderList: [],
        isUpdate: false,
        contactNumberDropdown: contactOptions,
        isExisting: 'Existing Customer',
        isExpanded: false
      });
    }
  }, [contactNumberData, selectedRow]);

  useEffect(() => {
    if (fromDate && toDate) {
      let payload: any = {
        tripStart: convertToEpoch2(fromDate),
        tripEnd: convertToEpoch2(toDate),
        vehicleNumber: vehicleNumber
      };
      dispatch(getDriverslist(payload));
    }
  }, [fromDate, toDate]);

  useEffect(() => {
    if (tripMarkers?.length < 1 && sourceAddress?.startLat) {
      setTripMarkers([
        {
          id: 'source',
          lat: sourceAddress?.startLat,
          lng: sourceAddress?.startLng,
          name: 'delivery',
          color: '#f01b1b',
          info: { Mylocation: 'source' }
        }
      ]);
    } else if (sourceAddress && tripMarkers?.some(marker => marker.id === 'source')) {
      setTripMarkers((prev: any) => {
        let updatedMarkers = prev?.map((marker: any) => ({
          ...marker,
          lat: marker.id === 'source' ? sourceAddress?.startLat : marker.lat,
          lng: marker.id === 'source' ? sourceAddress?.startLng : marker.lng
        }));
        return updatedMarkers;
      });
    } else if (sourceAddress && !tripMarkers?.some(marker => marker.id === 'source')) {
      setTripMarkers((prev: any) => {
        const updatedMarkers = [...prev];
        updatedMarkers.unshift({
          id: 'source',
          lat: sourceAddress?.startLat,
          lng: sourceAddress?.startLng,
          name: 'delivery',
          color: '#f01b1b',
          info: { Mylocation: 'source' }
        });
        return updatedMarkers;
      });
    }
  }, [sourceAddress?.formatted_address]);

  useEffect(() => {
    const [sourceMarker] = tripMarkers?.filter((item: any) => item?.id === 'source');
    if (deliveryLocation?.length > 0) {
      let waypoints = customerFields?.map((item: any, index: number) => ({
        id: deliveryLocation[index]?.name,
        lat: deliveryLocation[index]?.deliveryLat,
        lng: deliveryLocation[index]?.deliveryLng,
        color: '#40b800',
        name: 'waypoints',
        info: {
          Mylocation: `Customer ${index + 1}`,
          'Name ': `${item.customerName}`,
          'Contact No .': item?.contactNumber
        }
      }));

      if (sourceMarker && waypoints?.length > 0) {
        setTripMarkers([sourceMarker, ...waypoints]);
      } else if (waypoints?.length > 0 && !sourceAddress) {
        setTripMarkers([...waypoints]);
      } else if (sourceAddress) {
        setTripMarkers([
          {
            id: 'source',
            lat: sourceAddress?.startLat,
            lng: sourceAddress?.startLng,
            name: 'delivery',
            color: '#f01b1b',
            info: { Mylocation: 'source' }
          },
          ...waypoints
        ]);
      }
    } else if (sourceMarker) {
      setTripMarkers([sourceMarker]);
    } else if (deliveryLocation?.length === 0 && !sourceMarker) {
      setTripMarkers([]);
    }
  }, [deliveryLocation, deliveryLocation?.length]);

  useEffect(() => {
    if (previewData?.encodedPolyLine) {
      const polyLine = decode(previewData?.encodedPolyLine, 5).map(([lat, lng]) => ({
        lat,
        lng
      }));
      dispatch(
        updatePolyline([
          {
            id: 'actual',
            color: '#0f53ff',
            path: polyLine
          }
        ])
      );
    } else {
      dispatch(updatePolyline([]));
    }
  }, [previewData]);

  useEffect(() => {
    if (paths?.length > 0) {
      setShowCalendar(true);
    } else {
      setShowCalendar(false);
    }
  }, [paths]);

  useEffect(() => {
    if (
      tripMarkers?.length > 0 &&
      tripMarkers?.every(item => Boolean(item?.lat) && Boolean(item?.lng) === true)
    ) {
      dispatch(updateCenter(tripMarkers));
      dispatch(updateZoom(tripMarkers));
    }
  }, [tripMarkers]);

  useEffect(() => {
    dispatch(getDevices(createAbort().abortCall.signal));
    dispatch(getContactNumber());

    return () => {
      dispatch(updatePolyline([]));
      dispatch(clearDeliveryPreview());
    };
  }, []);

  return (
    <>
      {isOpen && (
        <Box className='adddelivery-trip'>
          <Dialog
            open={isOpen}
            fullScreen
            sx={{ padding: 3, zIndex: 1, position: 'absolute' }}
            className='add-trip-dialog'
            slotProps={{ backdrop: { invisible: true } }}
          >
            <DialogContent
              sx={{ overflow: 'hidden', padding: 1 }}
              className='adddelivery-trip-dialog-content'
            >
              <Grid container gap={1}>
                <Grid
                  item
                  xs={12}
                  md={7.6}
                  sm={7}
                  lg={4.5}
                  sx={{ overflow: 'hidden' }}
                  p={1}
                >
                  <Box
                    sx={{
                      width: `100%`,
                      height: '86vh',
                      overflow: 'hidden',
                      borderRadius: '10px'
                    }}
                  >
                    <GoogleMap isTrip={true}>
                      {paths?.length > 0 && <GooglePolyline />}
                      {tripMarkers?.length > 0 && (
                        <GoogleTripDirections
                          origin={sourceAddress}
                          locations={tripMarkers}
                          setTripMarker={setTripMarkers}
                          clearStartAndEndDate={clearDateandDriverDetails}
                          isDraggable
                          handleMarker={handleDeliveryMarker}
                        />
                      )}
                    </GoogleMap>
                  </Box>
                </Grid>
                <Grid item lg={7.3} md={4} sm={4.7}>
                  <Box>
                    <Typography className='adddelivery-typo'>
                      {selectedRow ? 'Update Trip' : 'Add Trip'}
                    </Typography>
                  </Box>
                  <Box className='deliverytrip-close'>
                    <Icon
                      icon='ic:round-close'
                      className='routes-close-icon'
                      onClick={() => {
                        handleClose();
                      }}
                    />
                  </Box>
                  <Box
                    className='deliverytrip-form'
                    component='form'
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <TabContext value={activeTab}>
                      {customerFields?.map((customer: any, customerIndex) => (
                        <TabPanel
                          key={customer.id}
                          value={String(customerIndex)}
                          sx={{ padding: '0 0 0 4px' }}
                        >
                          <Grid
                            container
                            columnSpacing={4}
                            sx={{ placeItems: 'baseline' }}
                          >
                            <Grid item lg={4} md={12} sm={12}>
                              <Controller
                                name={`customerList.${customerIndex}.contactNumber`}
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                  <PhoneNoTextField
                                    {...field}
                                    label='Contact Number'
                                    setValue={setValue}
                                    country={'in'}
                                    style='share'
                                    error={Boolean(
                                      (errors as any).customerList?.[customerIndex]
                                        ?.contactNumber
                                    )}
                                    helperText={
                                      (errors as any).customerList?.[customerIndex]
                                        ?.contactNumber?.message ||
                                      'Enter the Contact Number'
                                    }
                                    disabled={customer.isUpdate}
                                    onChange={(e: any) => {
                                      handleFields(e, customerIndex, 'contactNumber');
                                    }}
                                  />
                                )}
                              />
                            </Grid>

                            <Grid item lg={4} md={12} sm={12} sx={{ marginTop: '-8px' }}>
                              <CustomTextField
                                // key={`customerList.${customerIndex}.firstName`}
                                id={`customerName-${customerIndex}`}
                                control={control}
                                // inputRef={firstNameRef}
                                name={`customerList.${customerIndex}.customerName`}
                                label='Customer Name'
                                placeholder='Customer Name'
                                disabled={customer.isUpdate}
                                onChangeCallback={(e: any) => {
                                  handleFields(e, customerIndex, 'customerName');
                                }}
                              />
                            </Grid>

                            <Grid
                              item
                              lg={4}
                              md={12}
                              sm={12}
                              className='delivery-customeraddress'
                            >
                              <GoogleSearchBox
                                id={`deliveryAddress-${customerIndex}`}
                                name={`customerList.${customerIndex}.deliveryAddress`}
                                control={control}
                                label='Delivery Address'
                                placeholder='Delivery Address'
                                value={
                                  deliveryLocation &&
                                  deliveryLocation[customerIndex]?.delivery
                                }
                                onchange={(e: any) => {
                                  if (!e.target.value) {
                                    setDeliveryLocation((prev: any) => {
                                      let filteredLocation = prev?.filter(
                                        (item: any, index: number) =>
                                          index !== customerIndex
                                      );
                                      return filteredLocation;
                                    });
                                  }
                                }}
                                setAddress={(address: any) =>
                                  handleDeliveryLocationChange(customerIndex, address)
                                }
                              />
                            </Grid>
                            <Grid item lg={4} md={12} sm={12}>
                              <CustomSelect
                                id={`visitType-${customerIndex}`}
                                control={control}
                                name={`customerList.${customerIndex}.visitType`}
                                label='Order Type'
                                placeholder='Select Order Type'
                                options={visitTypeData}
                                values={{
                                  id: customer.visitType,
                                  label: customer.visiType
                                }}
                                onChanges={(e: any, newValue: any) =>
                                  updaetCustomer(customerIndex, {
                                    ...customerFields[customerIndex],
                                    visitType: newValue?.id ?? '',
                                    orderList:
                                      newValue?.id === 'DIRECT_SALES'
                                        ? []
                                        : [
                                            {
                                              deliveryBoxes: {
                                                barcodeId: [''],
                                                noOfBox: 1
                                              }
                                            }
                                          ]
                                  })
                                }
                              />
                            </Grid>
                            <Grid item lg={4} md={12} sm={12}>
                              <CustomDateTimeCalendar
                                id='startTime'
                                name='startTime'
                                className='calendar'
                                control={control}
                                disableFuture={false}
                                disablePast={true}
                                format='DD/MM/YYYY hh:mm a'
                                placeholder='Date and Time'
                                label='Date and Time'
                                value={fromDate}
                                // isDisabled={handleDisable('start-date')}
                                onDateChange={(e: any) => {
                                  if (e.$d && e.$d != 'Invalid Date') {
                                    setFromDate(e?.$d);
                                    setValue(
                                      'startTime',
                                      dayjs.unix(convertDatetoEpoch(e?.$d) / 1000)
                                    );
                                    clearErrors('startTime');
                                    setToDate(
                                      previewData?.totalDurationInSeconds &&
                                        dayjs(
                                          new Date(e).getTime() +
                                            1000 *
                                              (previewData?.totalDurationInSeconds + 600)
                                        )
                                    );
                                    previewData?.totalDurationInSeconds &&
                                      setValue(
                                        'endTime',
                                        dayjs(
                                          new Date(e).getTime() +
                                            1000 *
                                              (previewData?.totalDurationInSeconds + 600)
                                        )
                                      );
                                    clearErrors('endTime');
                                    setMinDateTime(
                                      previewData?.totalDurationInSeconds &&
                                        dayjs(
                                          new Date(e).getTime() +
                                            1000 * previewData?.totalDurationInSeconds +
                                            600
                                        )
                                    );
                                    setMaxDateTime(
                                      previewData?.totalDurationInSeconds &&
                                        dayjs(
                                          new Date(e).getTime() +
                                            1000 * previewData?.totalDurationInSeconds +
                                            3600
                                        )
                                    );
                                  }
                                }}
                              />
                            </Grid>
                            {customer?.orderList?.map(
                              (order: any, orderIndex: any) =>
                                customer?.visitType === 'ORDER_DELIVERY' && (
                                  <Grid
                                    container
                                    key={order.orderId}
                                    spacing={2}
                                    className='order-details-form'
                                    sx={{ marginTop: '5px', marginLeft: '32px' }}
                                  >
                                    <Box className='order-details' marginBottom={'10px'}>
                                      <Typography className='order-title'>
                                        Order Details
                                      </Typography>
                                    </Box>
                                    <Grid item md={12} sx={{ padding: '0 !important' }}>
                                      <Grid container spacing={1} columnSpacing={4}>
                                        <Grid
                                          item
                                          xs={5}
                                          md={6}
                                          lg={4}
                                          sm={6}
                                          className='order-fields'
                                        >
                                          <CustomTextField
                                            id={`noOfBox-${customerIndex}-${orderIndex}`}
                                            control={control}
                                            name={`customerList.${customerIndex}.orderList[${orderIndex}].deliveryBoxes.noOfBox`}
                                            label='Number of Box'
                                            placeholder='Number of Box'
                                            type='number'
                                            inputProps={{ maxLength: 5, min: 1 }}
                                            onChangeCallback={(e: any) => {
                                              handleAddBox(customerIndex, orderIndex, e);
                                            }}
                                          />
                                        </Grid>

                                        {getValues(
                                          `customerList.${customerIndex}.orderList.${orderIndex}.deliveryBoxes.barcodeId`
                                        )?.map((box: string, boxIndex: number) => (
                                          <Grid
                                            key={boxIndex}
                                            item
                                            lg={4}
                                            xs={5}
                                            md={6}
                                            sm={6}
                                            className='order-fields'
                                          >
                                            <CustomTextField
                                              key={boxIndex}
                                              id={`barcodeId-${customerIndex}-${orderIndex}-${boxIndex}`}
                                              control={control}
                                              name={`customerList.${customerIndex}.orderList.${orderIndex}.deliveryBoxes.barcodeId[${boxIndex}]`}
                                              label='Barcode ID'
                                              placeholder='Barcode ID'
                                              inputProps={{ maxLength: 13 }}
                                              // onChangeCallback={(e: any) => {
                                              //   handleBarcodeId(
                                              //     e.target.value,
                                              //     customerIndex,
                                              //     orderIndex,
                                              //     boxIndex
                                              //   );
                                              // }}
                                            />
                                          </Grid>
                                        ))}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                )
                            )}
                          </Grid>
                        </TabPanel>
                      ))}
                    </TabContext>

                    {/* <Grid container justifyContent={'flex-end'}>
                      <Grid item lg={2} md={5.8} sm={4} width={'100px'}>
                        <CustomButton
                          variant='outlined'
                          startIcon={<Visibility />}
                          category='Preview'
                          onClick={handlePreviewDelivery}
                          loading={previewLoading}
                          disabled={handleDisable('preview')}
                          className='custom-button-another'
                          fullWidth
                        />
                      </Grid>
                    </Grid> */}

                    {/* <Grid container columnSpacing={4} marginTop={'10px'}> */}
                    {/* <Grid item lg={4} md={12} sm={12}>
                        <CustomDateTimeCalendar
                          id='startTime'
                          name='startTime'
                          className='calendar'
                          control={control}
                          disableFuture={false}
                          disablePast={true}
                          format='DD/MM/YYYY hh:mm a'
                          placeholder='Start Date and Time'
                          label='Start Date and Time'
                          value={fromDate}
                          isDisabled={handleDisable('start-date')}
                          onDateChange={(e: any) => {
                            if (e.$d && e.$d != 'Invalid Date') {
                              setFromDate(e?.$d);
                              setValue(
                                'startTime',
                                dayjs.unix(convertDatetoEpoch(e?.$d) / 1000)
                              );
                              clearErrors('startTime');
                              setToDate(
                                previewData?.totalDurationInSeconds &&
                                  dayjs(
                                    new Date(e).getTime() +
                                      1000 * (previewData?.totalDurationInSeconds + 600)
                                  )
                              );
                              previewData?.totalDurationInSeconds &&
                                setValue(
                                  'endTime',
                                  dayjs(
                                    new Date(e).getTime() +
                                      1000 * (previewData?.totalDurationInSeconds + 600)
                                  )
                                );
                              clearErrors('endTime');
                              setMinDateTime(
                                previewData?.totalDurationInSeconds &&
                                  dayjs(
                                    new Date(e).getTime() +
                                      1000 * previewData?.totalDurationInSeconds +
                                      600
                                  )
                              );
                              setMaxDateTime(
                                previewData?.totalDurationInSeconds &&
                                  dayjs(
                                    new Date(e).getTime() +
                                      1000 * previewData?.totalDurationInSeconds +
                                      3600
                                  )
                              );
                            }
                          }}
                        />
                      </Grid> */}
                    {/* <Grid item lg={4} md={12} sm={12}>
                        <CustomDateTimeCalendar
                          id='endTime'
                          name='endTime'
                          className='calendar'
                          control={control}
                          disableFuture={false}
                          disablePast={true}
                          placeholder='End Date and Time'
                          format='DD/MM/YYYY hh:mm a'
                          label='End Date and Time'
                          value={toDate}
                          minDateTime={minDateTime}
                          maxDateTime={maxDateTime}
                          isDisabled={handleDisable('end-date')}
                          onDateChange={(e: any) => {
                            if (e) {
                              setToDate(e?.$d);
                              setValue(
                                'endTime',
                                dayjs.unix(convertDatetoEpoch(e?.$d) / 1000)
                              );
                              clearErrors('endTime');
                            }
                          }}
                        />
                      </Grid> */}
                    {/* <Grid item lg={4} md={12} sm={12}>
                        <CustomSelect
                          id='driverId'
                          control={control}
                          name='driverId'
                          label='Driver ID'
                          placeholder='Driver ID'
                          loading={isLoading}
                          isDisabled={handleDisable('driverid')}
                          options={availableDriversList}
                        />
                      </Grid> */}
                    {/* </Grid> */}
                    <Box mt={0.5}>
                      <CustomButton
                        category={selectedRow ? 'Update Trip' : 'Add Trip'}
                        className='saveChanges'
                        sx={{ marginRight: '10px' }}
                        loading={selectedRow ? updateLoading : addLoading}
                        type='submit'
                      />
                      <CustomButton
                        category='Cancel'
                        className='cancel'
                        onClick={handleClose}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Box>
      )}
    </>
  );
};
export default AddDeliveryTrip;
